/**
 * Client-side sizing setup: brands ({ id, name }) and per-chart metadata
 * (brand link, display name). No dedicated backend routes exist in this repo yet.
 */
const STORAGE_KEY = "avease_sizing_setup_v1";

function defaultState() {
  return { brands: [], chartMeta: {} };
}

export function loadSizingSetup() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState();
    const parsed = JSON.parse(raw);
    return {
      brands: Array.isArray(parsed.brands) ? parsed.brands : [],
      chartMeta:
        parsed.chartMeta && typeof parsed.chartMeta === "object"
          ? parsed.chartMeta
          : {},
    };
  } catch {
    return defaultState();
  }
}

export function saveSizingSetup(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}

export function normalizeBrandName(name) {
  if (typeof name !== "string") return "";
  return name.trim().replace(/\s+/g, " ");
}

export function isDuplicateBrandName(brands, name, excludeId) {
  const n = normalizeBrandName(name).toLowerCase();
  if (!n) return false;
  return brands.some(
    (b) =>
      b.id !== excludeId &&
      normalizeBrandName(b.name).toLowerCase() === n
  );
}

/** @returns {string[]} chart ids using this brand id */
export function getChartIdsUsingBrand(chartMeta, brandId) {
  if (!chartMeta || !brandId) return [];
  return Object.keys(chartMeta).filter(
    (chartId) => chartMeta[chartId]?.brandId === brandId
  );
}

/** Move saved chart meta when user switches to another sizing template id. */
export function migrateChartMeta(fromId, toId) {
  if (!fromId || !toId || fromId === toId) return;
  const prev = loadSizingSetup();
  const from = prev.chartMeta[fromId];
  if (!from) return;
  const next = {
    ...prev,
    chartMeta: { ...prev.chartMeta },
  };
  delete next.chartMeta[fromId];
  next.chartMeta[toId] = { ...next.chartMeta[toId], ...from };
  saveSizingSetup(next);
}
